import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import ImageSlider from './ImageSlider';

// Set REACT_APP_API_URL=https://api.eazyworldehsengineering.com in frontend/.env.production
const API = process.env.REACT_APP_API_URL || 'https://apiwebsite.eazyworldehsengineering.com';

const COURSES = [
  'Crane Operation (Mobile, Tower, EOT, Gantry)',
  'Lifting Supervision for Foremen, Riggers & Engineers',
  'Piling Rig Operations & Heavy Construction Equipment',
  'Forklift, Backhoe Loader & Excavator Safe Operation',
  'Boom Placer, Jig Lift & Aerial Lift Operations',
  'Lock Out & Tag Out (LOTO) Procedures',
];

const LANGS = ['Tamil', 'English', 'Hindi', 'Malayalam', 'Kannada', 'Marathi'];

const fadeUp = (delay = 0) => ({
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] },
});

export default function Training() {
  const [stats, setStats] = useState({ participants_trained: '46,471+', batches_delivered: '10,628+' });

  useEffect(() => {
    fetch(`${API}/api/stats`)
      .then(r => r.json())
      .then(setStats)
      .catch(() => { });
  }, []);

  return (
    <section id="training" className="section-pad bg-brand-surface relative overflow-hidden">
      <div className="container-xl relative z-10">
        <motion.span {...fadeUp()} className="section-label">
          <span className="w-8 h-px bg-brand-orange" /> Workforce Competence
        </motion.span>
        <motion.h2 {...fadeUp(0.1)} className="font-heading font-black text-4xl sm:text-5xl text-brand-heading mb-14 leading-tight">
          COMPETENCE <span className="text-gradient">TRAINING</span><br />MODEL
        </motion.h2>

        <div className="grid lg:grid-cols-2 gap-12">
          {/* Left */}
          <div>
            <motion.p {...fadeUp(0.15)} className="text-brand-subtle leading-relaxed mb-8">
              Eazyworld's closed-loop competency model transforms inspection findings into targeted coaching, practical checks, and supervisor reinforcement.
            </motion.p>

            <motion.div {...fadeUp(0.2)} className="grid grid-cols-2 gap-4 mb-8">
              {[
                { num: stats.participants_trained, label: 'Participants Trained' },
                { num: stats.batches_delivered, label: 'Batches Delivered' },
              ].map(s => (
                <div key={s.label} className="card rounded-2xl p-5 border-l-4 border-l-brand-orange">
                  <div className="font-heading font-black text-3xl text-gradient mb-1">{s.num}</div>
                  <div className="text-brand-subtle text-xs tracking-[1.5px] uppercase">{s.label}</div>
                </div>
              ))}
            </motion.div>

            <motion.div {...fadeUp(0.25)}>
              <p className="text-brand-heading text-xs font-bold tracking-[2px] uppercase mb-3">Multi-Lingual Delivery Across 6 Languages</p>
              <div className="flex flex-wrap gap-2 mb-8">
                {LANGS.map(l => (
                  <span key={l} className="px-3 py-1.5 rounded-lg orange-pill text-xs font-semibold">{l}</span>
                ))}
              </div>
            </motion.div>

            <motion.ul {...fadeUp(0.3)} className="space-y-2.5">
              {COURSES.map((c, i) => (
                <motion.li
                  key={c}
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: 0.05 * i }}
                  className="flex items-start gap-3 text-sm text-brand-subtle"
                >
                  <span className="w-5 h-5 rounded-md bg-orange-100 flex items-center justify-center text-brand-orange text-xs shrink-0 mt-0.5">▸</span>
                  {c}
                </motion.li>
              ))}
            </motion.ul>
          </div>

          {/* Right */}
          <div className="flex flex-col gap-5">
            <motion.div
              {...fadeUp(0.2)}
              className="rounded-2xl overflow-hidden border border-gray-200 shadow-card"
            >
              <video src="/videos/vidno4.mp4" autoPlay muted loop playsInline className="w-full h-full object-cover" />
            </motion.div>

            <motion.div {...fadeUp(0.3)} className="card rounded-2xl p-7 border-t-4 border-t-brand-orange">
              <p className="text-brand-orange text-xs font-bold tracking-[3px] uppercase mb-2">Plan Training Batch</p>
              <p className="text-brand-subtle text-sm mb-5">Schedule onsite competence evaluation and coaching for your workforce.</p>
              <a href="#contact" className="btn-primary">
                Schedule Training →
              </a>
            </motion.div>
          </div>
        </div>

        <div className="mt-12">
          <ImageSlider page="training" />
        </div>
      </div>
    </section>
  );
}
